import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from "./Variables.js";
import { FALSE } from 'sass';
export default function MatchHomePage() {

  const jsonUrl = variables.basename_url + "updates/index/Athlethixnet_HomeEn_Matches.json";
  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();
  async function refda() {
    Get_Data_FMostViewed();
  };
  const [Match_HomePage, setMatch_HomePage] = React.useState([]);
  const [Match_HomePageWithResult, setMatch_HomePageWithResult] = React.useState([]);


  async function Get_Data_FMostViewed() {

    Match_HomePage.splice(0);  //to clear All data in your page
    Match_HomePageWithResult.splice(0);


    setNisLoading(true);

    axios.get(jsonUrl)
      .then(function (response) {
        setNisLoading(false);

        const data = response.data;
        const Match_HomePage = [];
        const Match_HomePageWithResult = [];

        // Group by date (trim just in case)
        const groupedByDate = {};
        data.forEach(item => {
          const date = (item.SM_game_date_time || "").trim().split(" ")[0];
          if (!groupedByDate[date]) groupedByDate[date] = [];
          groupedByDate[date].push(item);
        });

        // Log grouping result
        console.log("Grouped dates:", groupedByDate);

        // Sort dates (latest → oldest)
        const sortedDates = Object.keys(groupedByDate)
          .sort((a, b) => {
            const [da, ma, ya] = a.split("-").map(Number);
            const [db, mb, yb] = b.split("-").map(Number);
            return new Date(yb, mb - 1, db) - new Date(ya, ma - 1, da);
          });

        console.log("Sorted dates:", sortedDates);

        // Take 2 matches per date (max 6)
        const filtered = sortedDates
          .flatMap(date => groupedByDate[date].slice(0, 2))
          .slice(0, 6);

        console.log("Filtered matches (before split):", filtered);

        // Build the output arrays
        filtered.forEach(item => {
          const parts = (item.SM_game_date_time || "").split(" ");
          const Day = parts[0]?.trim() || "";
          const Time1 = parts[1] || "";
          const Time2 = parts[2] || "";

          const matchObj = {
            SLT_name_en: item.SLT_name_en?.trim() || "",
            SLT_Logo: item.SLT_Logo,
            Day,
            Time1,
            Time2,
            Team1: item.Team1,
            Team2: item.Team2,
            ST_logo: item.ST_logo,
            ST_logo1: item.ST_logo1,
            SM_score1: item.SM_score1,
            SM_score2: item.SM_score2,
          };

          // ✅ LOG what's happening
          console.log(
            `Processing: ${Day} | ${item.Team1} vs ${item.Team2} | Scores: ${item.SM_score1}-${item.SM_score2}`
          );

          // If both scores are "-" => upcoming

          Match_HomePageWithResult.push(matchObj);

        });

        console.log("Match_HomePage (upcoming):", Match_HomePage);
        console.log("Match_HomePageWithResult:", Match_HomePageWithResult);

        setMatch_HomePage(Match_HomePage);
        setMatch_HomePageWithResult(Match_HomePageWithResult);
      })
      .catch(function (error) {
        console.error("Error fetching data:", error);
        setNisLoading(false);
      });

  }

  useEffect(() => {


    setNisLoading(true);

    refda();
  }, [])


  return (
    <>

      {/* break */}
      <div className="upcoming-matches-post mt-35 most-view-box mt-2 border ">
        <div className="section-title d-flex justify-content-between align-items-center">
          <h3 className="title">Latest Matches</h3>
          <a href="FootballMatches"> SEE ALL</a>
        </div>
        <div className="upcoming-matches-post-items">
          <div className="container ">
           
              {Match_HomePageWithResult.map(da =>
                <div key={da.SLT_name_en}  >
                  <div className=" row">
                    <div className=" match-card d-flex align-items-center justify-content-between p-3 border-0 rounded mb-3 ">
                      {/* Team 1 */}
                      <div className="team d-flex align-items-center flex-shrink-0" >
                        <img
                          src={variables.MatchesImg + da.ST_logo}
                          className="team-logo rounded-circle me-2"
                          alt={da.Team1}
                        />
                        <span className="team-name">{da.Team1}</span>
                      </div>
                      {/* Date or Score */}
                      <div className="match-info text-center px-3 flex-shrink-0 ">
                        {da.SM_score1 === '' || da.SM_score1 === '-1' ? (
                          <span className="match-date">{da.Day}</span>
                        ) : (
                          <span className="match-score">
                            {da.SM_score1} <span className="score-separator">-</span> {da.SM_score2}
                            <br></br>
                            {da.Day}
                          </span>
                         
                        )}
                      </div>

                      {/* Team 2 */}
                      <div className="team d-flex align-items-center justify-content-end flex-shrink-0" >
                        
                        <img
                          src={variables.MatchesImg + da.ST_logo1}
                          className="team-logo rounded-circle ms-2"
                          // alt={da.Team2}
                        />
                         <span className="team-name">{da.Team2}</span>
                      </div>
                      
                    </div>

                    <hr />
                    <div className="row">
                      <div className="col-12">
                        {/* <span>{da.Day}</span> */}
                        {/* <span className="  ml-3 timeee"><strong>{da.Time1} {da.Time2}</strong></span> */}
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  );
}